module.exports = __webpack_public_path__ + "img/pipefitters-logo.14ffb440.jpg";